import {
  useDataValue,
  useDataSubmit,
  useDataOriginalValue,
} from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let event_action_id = useDataValue({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'id',
  })

  let event_action_type = useDataValue({
    context: 'event_action',
    viewPath: props.viewPath,
    path: 'type',
  })

  let event_action_index = useDataValue({
    context: 'event_action_item',
    path: 'index',
    viewPath: props.viewPath,
  })

  let automation = useDataOriginalValue({
    context: 'automation',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'automation',
    viewPath: props.viewPath,
  })

  let setFlowTo = useSetFlowTo(props.viewPath)
  return function onClick() {
    let existing_action_ids = automation.actions.map(a => a.id)
    // if it is a new action being added, remove it directly, otherwise show the delete prompt
    if (existing_action_ids.indexOf(event_action_id) !== -1) {
      if (event_action_type === 'wait') {
        setFlowTo(normalizePath(props.viewPath, 'Wait'))
      } else {
        setFlowTo(normalizePath(props.viewPath, 'OtherActions'))
      }
    } else {
      submit({
        type: 'removeAction',
        index: event_action_index,
      })
    }
  }
}
